import envConfig from 'configs/envConfig';
import { TPartnerAssets } from 'partners/types';

export const lunaBaseUrl = `${envConfig('b2BucketUrl')}/luna`;

export const assets: TPartnerAssets = {
  logo: `${lunaBaseUrl}/logo.svg`,
  loginIllustration: `${lunaBaseUrl}/loginIllustration.svg`,
  Days30EventIcon: `${lunaBaseUrl}/30DaysEventIcon.svg`,
  CannotAddSelectedCameraIcon: `${lunaBaseUrl}/CannotAddSelectedCamera.svg`,
  attentionIcon: `${lunaBaseUrl}/attention.svg`,
  basicAlertsIcon: `${lunaBaseUrl}/basicAlertsIcon.svg`,
  basicMotionAlertsImg: `${lunaBaseUrl}/basicMotionAlerts.png`,
  clockIcon: `${lunaBaseUrl}/clockIcon.svg`,
  decriptiveAIAlertsIcon: `${lunaBaseUrl}/decriptiveAIAlertsIcon.svg`,
  descriptiveAIAlertsImg: `${lunaBaseUrl}/descriptiveAIAlerts.png`,
  firmwareVersionIcon: `${lunaBaseUrl}/firmwareVersionIcon.svg`,
  interntNotConnectedIcon: `${lunaBaseUrl}/interntNotConnected.svg`,
  limitedSecurityImg: `${lunaBaseUrl}/limitedSecurity.png`,
  limitedSecurityIcon: `${lunaBaseUrl}/limitedSecurityIcon.svg`,
  locationIcon: `${lunaBaseUrl}/location.svg`,
  logoContrastIcon: `${lunaBaseUrl}/logoContrast.svg`,
  logoWhiteIcon: `${lunaBaseUrl}/logoWhite.svg`,
  maxCameraLimitReachedIcon: `${lunaBaseUrl}/maxCameraLimitReached.svg`,
  AllCamerasAddedToAccountIcon: `${lunaBaseUrl}/AllCamerasAddedToAccount.svg`,
  noEventVideosImg: `${lunaBaseUrl}/noEventVideos.png`,
  noEventVideosIcon: `${lunaBaseUrl}/noEventVideosIcon.svg`,
  paymentFailedIcon: `${lunaBaseUrl}/paymentFailedIcon.svg`,
  paymentSuccessfulIcon: `${lunaBaseUrl}/PaymentSuccessful.svg`,
  planLevelOneIcon: `${lunaBaseUrl}/planLevelOneIcon.svg`,
  planLevelThreeIcon: `${lunaBaseUrl}/planLevelThreeIcon.svg`,
  planLevelTwoIcon: `${lunaBaseUrl}/planLevelTwoIcon.svg`,
  professionMonitoringIcon: `${lunaBaseUrl}/professionMonitoringIcons.svg`,
  professionalMonitoringImg: `${lunaBaseUrl}/professionalMonitoring.png`,
  sampleCreditCardIcon: `${lunaBaseUrl}/sampleCreditCard.svg`,
  FreeTrialActivatedIcon: `${lunaBaseUrl}/FreeTrialActivated.svg`,
  upgradeSnapshotIcon: `${lunaBaseUrl}/upgradeSnapshot.svg`,
  wifiIcon: `${lunaBaseUrl}/wifiIcon.svg`,
  appQRCode: `${lunaBaseUrl}/qrCode.png`
};
